import { NavigateFunction } from "react-router-dom";
import { AggregateWindow, FilterPoint} from "../types/types";

export const setFilterInURL = (filter: FilterPoint, location: string,  navigate: NavigateFunction) => {
    const params = new URLSearchParams(location);

    for (const key in filter) {
        if (filter[key as keyof FilterPoint]) {
            params.set(key, filter[key as keyof FilterPoint] as string)
        } else {
            params.delete(key)
        }
    }
    const path = location.split('?')[0] + '?' + params.toString()
    navigate(path, { replace: true });
}

export const getFilterFromURL = (location:string) : FilterPoint=> {

    return {
        startDate: new URLSearchParams(location).get('startDate')?.replace('%3A',':') || undefined,
        stopDate: new URLSearchParams(location).get('stopDate')?.replace('%3A',':')  || undefined,
        device_name: new URLSearchParams(location).get('device_name') ||    undefined,
        aggregateWindow: new URLSearchParams(location).get('aggregateWindow') as AggregateWindow
    }
}